import { apiClient } from "../client";
import type { Envelope } from "./catalog";

/**
 * Payment gateway option. Upstream shape is loosely documented — keep
 * permissive. The Razorpay entry's public key id may ride under any of a
 * few common field names depending on backend version, so all plausible
 * ones are typed here; `resolveRazorpayKey()` in the astrology app tries
 * them in order. Verified live response: identified by `gateway_name`
 * ("razorpay"), key rides under `credentials.key_id`.
 */
export interface PaymentGateway {
  id: number;
  name?: string | null;
  title?: string | null;
  slug?: string | null;
  /** Verified live field — e.g. "razorpay". */
  gateway_name?: string | null;
  /** Verified live field — e.g. "Razorpay". */
  display_name?: string | null;
  description?: string | null;
  logo?: string | null;
  image?: string | null;
  is_active?: boolean | number;
  key?: string | null;
  key_id?: string | null;
  public_key?: string | null;
  api_key?: string | null;
  config?: { key?: string | null; key_id?: string | null; [key: string]: unknown } | null;
  /** Verified live shape — the real home of the Razorpay public key id. */
  credentials?: { key?: string | null; key_id?: string | null; [key: string]: unknown } | null;
  [key: string]: unknown;
}

export const payments = {
  /** Available payment gateways for checkout. */
  gateways: () =>
    apiClient.get<Envelope<PaymentGateway[]> | PaymentGateway[]>("/payment-gateways"),
};
